import {appendQueryString, getExternalRequest} from "@pg-mono/request";
import {apiBigDataLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../../app/api/rp_api";
import {bigDataApiUrl} from "../../../app/read_rp_environment_variables";
import {getFetchQueryDataMonth} from "../helpers/get_fetch_query_data";
import {getTypeForFetch, PricesViewType} from "../helpers/prices_view_type";
import {getPricesAvailableDate} from "../utils/get_prices_available_date";

interface FetchDistrictsMonthlyStatsParams {
    date?: string;
    type: PricesViewType;
    regionSlug: string;
    monthsEarlierRange: {from: number; to: number};
}

export interface DistrictData {
    slug_district: string;
    district: string;
    avg_price_m2: number;
    avg_price_m2_studio: number | null;
    avg_price_m2_2_rooms: number | null;
    avg_price_m2_3_rooms: number | null;
    avg_price_m2_4_plus_rooms: number | null;
    date: string;
}

export const fetchDistrictsMonthlyStatsApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        // Zewnętrzne BigData API (poza serverApiUrls/rpServicesBaseQuery), stąd queryFn zamiast query.
        getDistrictsMonthlyStats: build.query<DistrictData[], FetchDistrictsMonthlyStatsParams>({
            queryFn: async (params) => {
                const endpointLink = apiBigDataLink.monthDistrictTypeStats.base(bigDataApiUrl);
                const referenceDate = getPricesAvailableDate(params.date);

                const link = appendQueryString(endpointLink, {
                    date_start: getFetchQueryDataMonth(params.monthsEarlierRange.from, referenceDate).date_start,
                    date_end: getFetchQueryDataMonth(params.monthsEarlierRange.to, referenceDate).date_end,
                    scenario: "rp-avg",
                    slug_city: params.regionSlug,
                    offer_type: getTypeForFetch(params.type)
                });

                try {
                    const data: DistrictData[] = await getExternalRequest({}, link, 5000);

                    return {data};
                } catch (error) {
                    return {error: {status: "CUSTOM_ERROR", error: String(error)}};
                }
            }
        })
    })
});
import {appendQueryString, getExternalRequest} from "@pg-mono/request";
import {apiBigDataLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../../app/api/rp_api";
import {bigDataApiUrl} from "../../../app/read_rp_environment_variables";
import {getFetchQueryDataMonth} from "../helpers/get_fetch_query_data";
import {getTypeForFetch, PricesViewType} from "../helpers/prices_view_type";
import {getPricesAvailableDate} from "../utils/get_prices_available_date";

interface FetchDistrictsMonthlyStatsParams {
    date?: string;
    type: PricesViewType;
    regionSlug: string;
    monthsEarlierRange: {from: number; to: number};
}

export interface DistrictData {
    slug_district: string;
    district: string;
    avg_price_m2: number;
    avg_price_m2_studio: number | null;
    avg_price_m2_2_rooms: number | null;
    avg_price_m2_3_rooms: number | null;
    avg_price_m2_4_plus_rooms: number | null;
    date: string;
}

export const fetchDistrictsMonthlyStatsApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        // Zewnętrzne BigData API (poza serverApiUrls/rpServicesBaseQuery), stąd queryFn zamiast query.
        getDistrictsMonthlyStats: build.query<DistrictData[], FetchDistrictsMonthlyStatsParams>({
            queryFn: async (params) => {
                const endpointLink = apiBigDataLink.monthDistrictTypeStats.base(bigDataApiUrl);
                const referenceDate = getPricesAvailableDate(params.date);

                const link = appendQueryString(endpointLink, {
                    date_start: getFetchQueryDataMonth(params.monthsEarlierRange.from, referenceDate).date_start,
                    date_end: getFetchQueryDataMonth(params.monthsEarlierRange.to, referenceDate).date_end,
                    scenario: "rp-avg",
                    slug_city: params.regionSlug,
                    offer_type: getTypeForFetch(params.type)
                });

                try {
                    const data: DistrictData[] = await getExternalRequest({}, link, 5000);

                    return {data};
                } catch (error) {
                    return {error: {status: "CUSTOM_ERROR", error: String(error)}};
                }
            }
        })
    })
});
